'use strict';

// Step1「リーグメンバー」画面のJS
// DOM id 契約:
//   config div: #team-members-config[data-config]
//   #s1Count, #s1MemberList, #s1NewName, #s1NewAdd
//   #inviteUrl, #inviteCopy, #inviteCheck
//   #barNote, #barNoteText, #barNext
//   #toast, #toastText
//   form id=members-form

(function () {
  // ===== 状態 =====
  var config = null;
  var icons = {};
  var i18n = {};
  var members = [];        // [{ id, name, isSelf, authenticated, role, isNew }]
  var newPlayerIds = [];   // 新規追加した名前群
  var addedAuthIds = [];   // 認証確認で取り込んだ既存プレイヤーID群
  var removedIds = [];     // 除外した既存プレイヤーID群
  var nextTempId = -1;     // 新規プレイヤーの仮ID（負値）
  var playedPickSelectedIds = [];  // 対局済み選択シートで選択中のプレイヤーID群
  var playedSortMode = 'recent';   // 並び順: 'recent' | 'name'

  var PLAY_TYPE_MIN = 4;   // 最低人数（仮定: 四麻基準）

  // ===== ユーティリティ =====
  function esc(str) {
    return JanrecoUtils.escapeHtml(String(str));
  }

  function el(id) {
    return document.getElementById(id);
  }

  function showToast(msg, type) {
    window.TeamUiShared.showToast(msg, type);
  }

  function csrfToken() {
    var meta = document.querySelector('meta[name="csrf-token"]');
    return meta ? meta.content : '';
  }

  // ===== メンバー一覧の描画 =====
  function renderMembers() {
    var list = el('s1MemberList');
    if (!list) return;

    list.innerHTML = '';
    members.forEach(function (m) {
      var row = document.createElement('div');
      row.className = 'member-row';

      // タグHTML（識別タグと役割バッジを共存表示）
      var tagHtml = '';
      if (m.isSelf) {
        tagHtml += '<span class="member-tag">' + esc(i18n.tagYou) + '</span>';
      } else if (m.authenticated) {
        tagHtml += '<span class="member-tag gray">' + esc(i18n.tagAuthenticated) + '</span>';
      }
      // 役割バッジ（識別タグと共存）
      if (m.role === 'kuroko') {
        tagHtml += '<span class="member-tag role-kuroko">' + icons.kuroko + esc(i18n.kurokoLabel) + '</span>';
      } else if (m.role === 'record_only') {
        tagHtml += '<span class="member-tag role-recorder">' + icons.recorder + esc(i18n.recorderLabel) + '</span>';
      }

      // hasMatch のときロックタグを追加（roleタグとは共存）
      if (m.hasMatch) {
        tagHtml += '<span class="member-tag lock">' + icons.lock + esc(i18n.tagHasRecord) + '</span>';
      }

      // 除外ボタン（自分・対局成績ありは非表示）
      var removeBtnHtml = '';
      if (!m.isSelf && !m.hasMatch) {
        var removeAriaLabel = (i18n.removeMemberAria || '').replace('%{name}', esc(m.name));
        removeBtnHtml =
          '<button class="member-remove" type="button" data-pid="' + m.id + '" aria-label="' + removeAriaLabel + '">' +
            icons.remove +
          '</button>';
      }

      row.innerHTML =
        '<span class="member-avatar">' + esc(m.name.charAt(0)) + '</span>' +
        '<span class="member-name">' + esc(m.name) + '</span>' +
        tagHtml +
        removeBtnHtml;

      list.appendChild(row);
    });

    // 人数カウント更新
    var countEl = el('s1Count');
    if (countEl) countEl.textContent = members.length;

    // 「記録あり」メンバーがいる場合のセクション内注記の表示切り替え
    var matchInfoEl = el('s1MatchInfo');
    if (matchInfoEl) {
      if (members.some(function (m) { return m.hasMatch; })) {
        matchInfoEl.removeAttribute('hidden');
      } else {
        matchInfoEl.setAttribute('hidden', 'hidden');
      }
    }

    // 下部バー更新
    updateBar();
  }

  // ===== 下部バーのバリデーション =====
  function updateBar() {
    var noteEl = el('barNote');
    var noteTextEl = el('barNoteText');
    var nextBtn = el('barNext');
    if (!noteEl || !noteTextEl || !nextBtn) return;

    var minPlayers = config ? (config.playType || PLAY_TYPE_MIN) : PLAY_TYPE_MIN;
    var count = members.length;

    if (count < minPlayers) {
      noteEl.classList.remove('ok');
      var svgEl = noteEl.querySelector('svg');
      if (svgEl) svgEl.style.display = '';
      noteTextEl.textContent = window.Janreco.pluralize(i18n.needMore, minPlayers - count);
      nextBtn.disabled = true;
    } else {
      noteEl.classList.add('ok');
      var svgEl = noteEl.querySelector('svg');
      if (svgEl) svgEl.style.display = 'none';
      noteTextEl.textContent = window.Janreco.pluralize(i18n.memberCountBar, count);
      nextBtn.disabled = false;
    }
  }

  // ===== 新規プレイヤー追加 =====
  function addNewPlayer() {
    var input = el('s1NewName');
    if (!input) return;

    var name = input.value.trim();
    if (!name) {
      showToast(i18n.toastNameRequired, 'warn');
      return;
    }

    var maxLen = config ? (config.playerNameMaxLength || 8) : 8;
    if (name.length > maxLen) {
      showToast(window.Janreco.pluralize(i18n.toastPlayerNameMaxlen, maxLen), 'warn');
      return;
    }

    var maxPlayers = config ? (config.maxLeaguePlayers || 50) : 50;
    if (members.length >= maxPlayers) {
      showToast(window.Janreco.pluralize(i18n.toastPlayerLimit, maxPlayers), 'warn');
      return;
    }

    var tempId = nextTempId--;
    var newMember = { id: tempId, name: name, isNew: true };
    members.push(newMember);
    newPlayerIds.push(name);

    input.value = '';
    input.focus();
    // 入力が空になったので追加ボタンを非活性に戻す
    syncAddBtnState();
    renderMembers();
  }

  // ===== 追加ボタンの活性/非活性を入力値に応じて切り替える =====
  function syncAddBtnState() {
    var input = el('s1NewName');
    var addBtn = el('s1NewAdd');
    if (!addBtn) return;
    addBtn.disabled = !input || input.value.trim() === '';
  }

  // ===== 追加方法タブの切り替え（名前 / 過去の対戦相手 / 招待） =====
  var addTabs = [
    { tab: 'addTabName', panel: 'addPanelName' },
    { tab: 'addTabPlayed', panel: 'addPanelPlayed' },
    { tab: 'addTabInvite', panel: 'addPanelInvite' }
  ];

  function activateAddTab(targetTabId) {
    addTabs.forEach(function (t) {
      var tabEl = el(t.tab);
      var panelEl = el(t.panel);
      var isActive = t.tab === targetTabId;
      if (tabEl) {
        tabEl.classList.toggle('is-active', isActive);
        tabEl.setAttribute('aria-selected', isActive ? 'true' : 'false');
      }
      if (panelEl) {
        if (isActive) {
          panelEl.removeAttribute('hidden');
        } else {
          panelEl.setAttribute('hidden', 'hidden');
        }
      }
    });
  }

  // ===== 認証済みプレイヤー確認 =====
  function checkAuthenticatedUsers() {
    if (!config || !config.checkAuthenticatedUsersUrl) {
      showToast(i18n.toastConfigNotLoaded, 'warn');
      return;
    }

    var btn = el('inviteCheck');
    if (btn) btn.disabled = true;

    fetch(config.checkAuthenticatedUsersUrl, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'X-CSRF-Token': csrfToken()
      },
      credentials: 'same-origin'
    }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    }).then(function (response) {
      var added = 0;
      var limitReached = false;
      var maxPlayers = config.maxLeaguePlayers || 50;
      var existingIds = members.map(function (m) { return m.id; });

      response.forEach(function (p) {
        if (existingIds.indexOf(p.id) !== -1) return;
        if (members.length >= maxPlayers) { limitReached = true; return; }
        members.push({ id: p.id, name: p.name, authenticated: true, hasAccount: true });
        addedAuthIds.push(p.id);
        existingIds.push(p.id);
        added++;
      });

      if (added > 0) {
        showToast(window.Janreco.pluralize(i18n.toastAuthenticatedConfirmed, added));
        renderMembers();
      } else if (!limitReached) {
        showToast(i18n.toastNoNewlyAuthenticated, 'warn');
      }
      if (limitReached) {
        showToast(window.Janreco.pluralize(i18n.toastPlayerLimit, maxPlayers), 'warn');
      }
    }).catch(function (e) {
      console.error('認証確認エラー:', e);
      showToast(i18n.toastCheckError, 'warn');
    }).finally(function () {
      if (btn) btn.disabled = false;
    });
  }

  // ===== メンバー除外 =====
  function removeMember(pid) {
    var pidNum = Number(pid);
    var member = members.filter(function (m) { return m.id === pidNum; })[0];
    if (!member) return;
    if (member.isSelf) return;
    if (member.hasMatch) return;

    members = members.filter(function (m) { return m.id !== pidNum; });

    // 新規プレイヤー（仮ID）なら newPlayerIds から名前も除外する
    if (member.isNew) {
      var idx = newPlayerIds.indexOf(member.name);
      if (idx !== -1) newPlayerIds.splice(idx, 1);
    } else {
      // 既存プレイヤーなら removed リストに追加
      // 認証確認で取り込んだプレイヤーも既存IDなので removedIds に追加する
      if (removedIds.indexOf(pidNum) === -1) {
        removedIds.push(pidNum);
      }
      // addedAuthIds からも除外
      var authIdx = addedAuthIds.indexOf(pidNum);
      if (authIdx !== -1) addedAuthIds.splice(authIdx, 1);
    }

    renderMembers();
  }

  // ===== submit 直前に hidden input を構築 =====
  // A → POST saveMembersUrl（form=members-form）
  // - new_player_names[] （新規追加した名前群）
  // - add_to_league_player_ids[] （認証確認で取り込んだ既存プレイヤーID群）
  // - removed_player_ids[] （除外した既存プレイヤーID群）
  function buildHiddenInputs() {
    var form = document.getElementById('members-form');
    if (!form) return;

    // 前回の注入分をクリア
    form.querySelectorAll('.js-hidden-submit').forEach(function (inp) {
      inp.parentNode.removeChild(inp);
    });

    function addHidden(name, value) {
      var inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = name;
      inp.value = value;
      inp.className = 'js-hidden-submit';
      form.appendChild(inp);
    }

    // 新規プレイヤー名
    newPlayerIds.forEach(function (name) {
      // 既に removed したものは送らない（仮IDで管理しているため名前の突合が難しいが
      // removeから呼ぶときにnewPlayerIdsからも削除済みなので、ここにある = 送信対象）
      addHidden('new_player_names[]', name);
    });

    // 認証確認で取り込んだ既存プレイヤーID
    addedAuthIds.forEach(function (id) {
      addHidden('add_to_league_player_ids[]', id);
    });

    // 除外した既存プレイヤーID
    removedIds.forEach(function (id) {
      addHidden('removed_player_ids[]', id);
    });
  }

  // ===== 対局済みプレイヤー選択シート =====
  function renderPlayedPick() {
    var list = el('playedPickList');
    if (!list) return;
    list.innerHTML = '';

    // 現在のメンバーに含まれないプレイヤーのみ候補に表示
    var existingIds = members.map(function (m) { return m.id; });
    var candidates = (config.playedPlayers || []).filter(function (p) {
      return existingIds.indexOf(p.id) === -1;
    });

    // 並び順の適用（nameのときだけソート。recentはconfig順のまま）
    if (playedSortMode === 'name') {
      candidates = candidates.slice().sort(function (a, b) {
        return String(a.name).localeCompare(String(b.name), 'ja');
      });
    }

    if (candidates.length === 0) {
      var empty = document.createElement('p');
      empty.className = 'empty-candidates-note';
      empty.textContent = i18n.playedAllAdded;
      list.appendChild(empty);
    }

    candidates.forEach(function (p) {
      var row = document.createElement('div');
      var isSelected = playedPickSelectedIds.indexOf(p.id) !== -1;
      row.className = 'candidate-row' + (isSelected ? ' selected' : '');
      row.innerHTML =
        '<span class="candidate-check">' + icons.check + '</span>' +
        '<span class="candidate-name">' + esc(p.name) + '</span>';
      row.addEventListener('click', function () {
        var idx = playedPickSelectedIds.indexOf(p.id);
        if (idx !== -1) {
          playedPickSelectedIds.splice(idx, 1);
        } else {
          playedPickSelectedIds.push(p.id);
        }
        renderPlayedPick();
      });
      list.appendChild(row);
    });

    var n = playedPickSelectedIds.length;
    var confirmBtn = el('playedPickConfirm');
    if (confirmBtn) {
      confirmBtn.disabled = n === 0;
      confirmBtn.textContent = window.Janreco.pluralize(i18n.addCount, n);
    }
  }

  // ===== 初期化 =====
  function init() {
    var configEl = el('team-members-config');
    if (!configEl) return; // このページ以外では起動しない

    try {
      config = JSON.parse(configEl.dataset.config);
      icons = JSON.parse(configEl.dataset.icons || '{}');
      i18n = JSON.parse(configEl.dataset.i18n || '{}');
    } catch (e) {
      console.error('members config の parse に失敗:', e);
      return;
    }

    // 状態リセット
    members = [];
    newPlayerIds = [];
    addedAuthIds = [];
    removedIds = [];
    nextTempId = -1;
    playedPickSelectedIds = [];

    // 初期メンバーを構築
    // currentPlayer（リーグ作成者）は isSelf:true で先頭に配置
    if (config.currentPlayer) {
      members.push({
        id: config.currentPlayer.id,
        name: config.currentPlayer.name,
        isSelf: true,
        hasAccount: true
      });
    }

    // 既存メンバー（players）を追加（currentPlayerは重複しないようにする）
    var selfId = config.currentPlayer ? config.currentPlayer.id : null;
    (config.players || []).forEach(function (p) {
      if (p.id === selfId) return; // currentPlayerは既に追加済み
      members.push({
        id: p.id,
        name: p.name,
        hasAccount: p.hasAccount || false,
        role: p.role || 'regular',
        hasMatch: p.hasMatch || false,
        isSelf: p.isSelf || false
      });
    });

    // 招待URL表示
    var inviteUrlEl = el('inviteUrl');
    if (inviteUrlEl && config.authenticationUrl) {
      inviteUrlEl.textContent = config.authenticationUrl;
    }

    // 招待QRコード表示
    var inviteQrEl = el('inviteQr');
    if (inviteQrEl && config.authenticationUrl) {
      $.ajax({
        url: '/qr_codes',
        method: 'GET',
        data: { url: config.authenticationUrl },
        success: function(data) {
          inviteQrEl.innerHTML = data.qr_code;
        },
        error: function() {
          console.error('QRコード生成に失敗しました');
        }
      });
    }

    // コピーボタン
    var copyBtn = el('inviteCopy');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var url = config.authenticationUrl || '';
        if (navigator.clipboard && url) {
          navigator.clipboard.writeText(url).then(function () {
            showToast(i18n.inviteCopied);
          }).catch(function () {
            showToast(i18n.copyFailed, 'warn');
          });
        } else {
          showToast(i18n.copyFailed, 'warn');
        }
      });
    }

    // 認証確認ボタン
    var checkBtn = el('inviteCheck');
    if (checkBtn) {
      checkBtn.addEventListener('click', checkAuthenticatedUsers);
    }

    // 新規追加ボタン
    var addBtn = el('s1NewAdd');
    if (addBtn) {
      addBtn.addEventListener('click', addNewPlayer);
    }

    // Enterキーで追加 / 入力値に応じてボタン活性を切り替え
    var nameInput = el('s1NewName');
    if (nameInput) {
      nameInput.addEventListener('input', syncAddBtnState);
      nameInput.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        // IME変換確定のEnterでは追加しない（変換中は isComposing / keyCode 229）
        if (e.isComposing || e.keyCode === 229) return;
        e.preventDefault();
        addNewPlayer();
      });
    }
    // 初期状態（空欄）では追加ボタンを非活性にする
    syncAddBtnState();

    // タブ切り替え時に選択・並び順をリセットしてから描画
    function resetAndRenderPlayedPick() {
      playedPickSelectedIds = [];
      // タブ切り替えのたびに並び順をデフォルト（最近同卓した順）にリセット
      playedSortMode = 'recent';
      var sortRecentBtn = el('playedSortRecent');
      var sortNameBtn = el('playedSortName');
      if (sortRecentBtn) sortRecentBtn.classList.add('is-active');
      if (sortNameBtn) sortNameBtn.classList.remove('is-active');
      renderPlayedPick();
    }

    // 追加方法タブの切り替え
    addTabs.forEach(function (t) {
      var tabEl = el(t.tab);
      if (!tabEl) return;
      tabEl.addEventListener('click', function () {
        activateAddTab(t.tab);
        // 「名前で追加」タブに切り替えたら入力欄へフォーカス
        if (t.tab === 'addTabName') {
          var focusInput = el('s1NewName');
          if (focusInput) focusInput.focus();
        }
        // 「過去の対戦相手」タブに切り替えたら候補リストをリセット・再描画
        if (t.tab === 'addTabPlayed') {
          resetAndRenderPlayedPick();
        }
      });
    });
    // 初期は「名前で追加」タブを表示
    activateAddTab('addTabName');

    // メンバー除外（イベント委譲）
    var memberList = el('s1MemberList');
    if (memberList) {
      memberList.addEventListener('click', function (e) {
        var btn = e.target.closest('.member-remove');
        if (!btn) return;
        removeMember(btn.dataset.pid);
      });
    }

    // playedPlayers が空なら「過去の対戦相手」タブごと非表示
    if (!config.playedPlayers || config.playedPlayers.length === 0) {
      var playedTab = el('addTabPlayed');
      if (playedTab) playedTab.hidden = true;
      var playedPanel = el('addPanelPlayed');
      if (playedPanel) playedPanel.setAttribute('hidden', 'hidden');
    }

    // 対局済み確定ボタン
    var playedConfirmBtn = el('playedPickConfirm');
    if (playedConfirmBtn) {
      playedConfirmBtn.addEventListener('click', function () {
        var maxPlayers = config.maxLeaguePlayers || 50;
        var added = 0;
        playedPickSelectedIds.forEach(function (pid) {
          if (members.length >= maxPlayers) return;
          var p = (config.playedPlayers || []).filter(function (pp) { return pp.id === pid; })[0];
          if (!p) return;
          members.push({ id: p.id, name: p.name, hasAccount: p.hasAccount || false, authenticated: false });
          addedAuthIds.push(p.id);
          added++;
        });
        playedPickSelectedIds = [];
        renderMembers();
        renderPlayedPick();
        if (added > 0) {
          showToast(window.Janreco.pluralize(i18n.addedCount, added));
        }
        if (members.length >= maxPlayers) {
          showToast(window.Janreco.pluralize(i18n.toastPlayerLimit, maxPlayers), 'warn');
        }
      });
    }

    // 並び順トグル（最近同卓した順）
    var sortRecentBtn = el('playedSortRecent');
    if (sortRecentBtn) {
      sortRecentBtn.addEventListener('click', function () {
        playedSortMode = 'recent';
        sortRecentBtn.classList.add('is-active');
        var sortNameBtn = el('playedSortName');
        if (sortNameBtn) sortNameBtn.classList.remove('is-active');
        renderPlayedPick();
      });
    }

    // 並び順トグル（名前順）
    var sortNameBtn = el('playedSortName');
    if (sortNameBtn) {
      sortNameBtn.addEventListener('click', function () {
        playedSortMode = 'name';
        sortNameBtn.classList.add('is-active');
        var sortRecentBtn2 = el('playedSortRecent');
        if (sortRecentBtn2) sortRecentBtn2.classList.remove('is-active');
        renderPlayedPick();
      });
    }

    // シートの閉じる操作（[data-close]・背景クリック）は
    // TeamUiShared.bindSheetDismiss が全ページ共通で処理する

    // フォーム submit 前に hidden input を構築
    var form = document.getElementById('members-form');
    if (form) {
      form.addEventListener('submit', function () {
        buildHiddenInputs();
      });
    }

    renderMembers();
  }

  // ===== Turbolinks ライフサイクル =====
  document.addEventListener('turbolinks:load', function () {
    init();
  });

  document.addEventListener('turbolinks:before-cache', function () {
    // トースト状態をリセット
    var toast = el('toast');
    if (toast) toast.classList.remove('show');

    // メンバーリストをクリア（キャッシュに動的HTMLを残さない）
    var list = el('s1MemberList');
    if (list) list.innerHTML = '';

    var countEl = el('s1Count');
    if (countEl) countEl.textContent = '0';

    // 追加方法タブを初期状態（名前で追加）へ戻す
    activateAddTab('addTabName');
  });
})();
